import React from 'react';
import { Platform, Pressable, StyleSheet, Text, View } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import { BorrowRequestsManager } from '../borrowRequests/BorrowRequestsManager';
import { fpColors } from '../../styles/theme';
import { goBackOrHome } from '../../navigation/goBackOrHome';

/**
 * Thin wrapper that exposes the existing BorrowRequestsManager under a
 * dedicated route with the Fidelity Purple top bar. The manager itself
 * is not restyled in this pass — keeping it functional here lets us
 * remove the legacy Requests tab from the Sharing hub without losing
 * the feature. A full restyle lands in a later pass.
 */
export const SharingRequestsScreen: React.FC = () => {
  const navigation = useNavigation();
  return (
    <View style={styles.page}>
      <View style={styles.topBar}>
        <Pressable
          onPress={() => goBackOrHome(navigation)}
          style={styles.backBtn}
          hitSlop={8}
          accessibilityRole="button"
          accessibilityLabel="Back"
          testID="header-back-btn"
        >
          <MaterialIcons name="arrow-back" size={22} color={fpColors.onSurface} />
        </Pressable>
        <Text style={styles.topTitle}>Borrow requests</Text>
        <View style={{ width: 36 }} />
      </View>
      <View style={{ flex: 1 }}>
        <BorrowRequestsManager />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  page: { flex: 1, backgroundColor: fpColors.background },
  topBar: {
    height: Platform.OS === 'ios' ? 104 : 68,
    paddingTop: Platform.OS === 'ios' ? 48 : 12,
    paddingHorizontal: 12,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: fpColors.surfaceContainerLowest,
    borderBottomWidth: 1,
    borderBottomColor: fpColors.outlineVariant,
  },
  backBtn: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: fpColors.surfaceContainerLow,
    justifyContent: 'center',
    alignItems: 'center',
  },
  topTitle: {
    flex: 1,
    textAlign: 'center',
    fontFamily: 'Inter_700Bold',
    fontSize: 16,
    color: fpColors.onSurface,
  },
});
